import React from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import './index.scss';

// passing props as selected tab, tab data and change function
export default function CustomTabs({
  selectedTab,
  tabData,
  handleToggleChange
}) {
  const RenderLabelWithIcon = (props: { path: string; text: string }) => {
    const { path, text } = props;
    return (
      <div className='label-with-icon'>
        <img className='tab-icon' src={path} />
        <span style={{ marginLeft: '6px' }}>{text}</span>
      </div>
    );
  };

  const tabComponent = (tabsData: any[]) => {
    return (
      <TabContext value={selectedTab}>
        <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
          <TabList
            onChange={handleToggleChange}
            aria-label='lab API tabs example'
          >
            {tabsData.map((ele, index) => (
              <Tab
                label={
                  <RenderLabelWithIcon
                    path={`/media/${ele.icon}`}
                    text={ele.label}
                  />
                }
                id={`tab-${index}`}
                aria-controls={`tabpanel-${index}`}
                sx={{ textTransform: 'none' }}
                value={ele.value as string}
              />
            ))}
          </TabList>
        </Box>
      </TabContext>
    );
  };
  return tabComponent(tabData);
}
